/* istanbul ignore file */
import { ComposedTheme, registerDefaultsForModule } from '@glu/theming';

const theme = ({ palette, typography }: ComposedTheme) => ({
  backgroundColor: {
    // @theming labelText: Primary Background Color, type: color
    primaryBackgroundColor: palette.background,
    // @theming labelText: Secondary Background Color, type: color
    secondaryBackgroundColor: '#000000',
  },
  color: {
    // @theming labelText: Primary Text Color, type: color, backgroundColor: tooltip.backgroundColor.primaryBackgroundColor
    primaryColor: palette.text.dark,
    // @theming labelText: Secondary Text Color, type: color, backgroundColor: tooltip.backgroundColor.secondaryBackgroundColor
    secondaryColor: palette.text.light,
  },
  // @theming labelText: Tooltip Border Radius, type: pixel
  borderRadius: 2,
  // @theming labelText: Tooltip box Shadow, type: string
  boxShadow: '0 2px 8px 0 rgba(0,0,0,0.20)',
  // @theming labelText: Tooltip Font Size, type: pixel
  fontSize: typography.fontSize,
  // @theming labelText: Tooltip Font Family, type: fontFamily
  fontFamily: typography.fontFamily,
});

registerDefaultsForModule('tooltip', theme);

export default theme;
